export default __webpack_public_path__ + "static/lb-03-362f96a56610c5d093b0b900df9e686f.webp";